import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import serialize from 'serialize-javascript';
import { createBrowserHistory, createMemoryHistory } from 'history';
import createReducer from './reducers';

export const isServer = !(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

export const populatePreload = store => `<script>window.__PRELOADED_STATE__ = ${serialize(store.getState())}</script>`;

export default (url = '/') => {

  // Create a history depending on the environment
  const history = isServer
    ? createMemoryHistory({
      initialEntries: [url]
    })
    : createBrowserHistory();

  const enhancers = [];

  // Dev tools are helpful
  if (process.env.NODE_ENV === 'development' && !isServer) {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  const middleware = [thunk];

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );

  // Do we have preloaded state available? Great, save it.
  const initialState = !isServer ? window.__PRELOADED_STATE__ : {};

  // Delete it once we have it stored in a variable
  if (!isServer) {
    delete window.__PRELOADED_STATE__;
  }

  // Create the store
  const store = createStore(
    createReducer(),
    initialState,
    composedEnhancers
  );

  if (!isServer) {
    window.__HDHOME__ = store;
  }

  return {
    store,
    history
  };
};